import { NgModule } from '@angular/core';
import { ProductsListComponent } from './products-list/products-list.component';
import { RouterModule, Routes } from '@angular/router';
import { DetailProductsComponent } from './detail-products/detail-products.component';
import { HistoryComponent } from './detail-products/distributor-exclusive/history/history.component';
import { PublishRequestComponent } from './publish-request/publish-request.component';
import { EditPublishRequestComponent } from './edit-publish-request/edit-publish-request.component';
import { ValidateQrProductPageComponent } from './validate-qr-product-page/validate-qr-product-page.component';
import { QrProductsListComponent } from './qr-products/qr-products-list/qr-products-list.component';
import { QrBatchDetailComponent } from './qr-products/qr-batch-detail/qr-batch-detail.component';
import { QrBatchAddComponent } from './qr-products/qr-batch-add/qr-batch-add.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'list-published',
    pathMatch: 'full',
  },

  {
    path: 'list-published',
    component: ProductsListComponent,
  },

  {
    path: 'publish-request',
    component: PublishRequestComponent,
  },

  {
    path: 'publish-request/edit/:id',
    component: EditPublishRequestComponent,
  },

  {
    path: 'detail/:id',
    component: DetailProductsComponent,
    data: {
      enum: 'DETAIL_PRODUCT',
    },
  },

  {
    path: 'detail/distributor-exclusive/:id',
    component: HistoryComponent,
  },

  {
    path: 'detail/edit/:id',
    component: EditPublishRequestComponent,
  },

  {
    path: 'detail/validate/:id',
    component: ValidateQrProductPageComponent,
  },

  // QR Products
  {
    path: 'list-qr-produk',
    component: QrProductsListComponent,
  },

  {
    path: 'qr-produk/:id',
    component: QrBatchDetailComponent,
  },

  {
    path: 'generate-qr-batch',
    component: QrBatchAddComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductsRoutingModule {}
